import { config } from "config";
import { options } from "utils";

export const  getSeguros = async (q ='') => {
  const url = `${config.URL_API_PRIVATE}/precios/seguros?${q}`;
  const resp = await fetch(url, options("GET"));
  const data = await resp.json();
  return data;
};

export const updateSeguro = async (body) => {
  const resp = await fetch(`${config.URL_API_PRIVATE}/precios/seguros`, options("PUT", body))
  const data = await resp.json()
  return data
};

export const getClientePoliza = async (id) => {
  const resp = await fetch(`${config.URL_API_PRIVATE}/cliente/poliza/`+id, options("GET"))
  const data = await resp.json()
  return data
};

export const updateVigencia = async (body) => {
  const resp = await fetch(`${config.URL_API_PRIVATE}/acuerdos/actualizarvigencia`, options("PUT", body))
  const data = await resp.json()
  return data
};